import f from "../../funcs";
import $ from "jquery";
import Events from "../Events";
import "../../plugins/realSize";


const isMobile = f.aboutBrow().isMobile;

let zIndex = 3000;

let id = 0;
let activeModal = {
    hide() {}
};

const DragModal = f.CreateClass("DragModal", {}, Events);
let $modalContainer;
DragModal.modals = {};
DragModal.activeModal = function(modal) {
    activeModal = modal;
};

DragModal.prototype.isActiveModal = function() {
    return this == activeModal;
};

DragModal.prototype.init = function(params) {
    this.id = ++id;
    DragModal.modals[this.id] = this;

    if ( !$modalContainer ) {
        $modalContainer = $("<div class='modals-container'></div>");
        $(document.body).prepend($modalContainer);
    }

    params = f.deepMixin({
        ihelp: true,
        imin: true,
        ifull: true,
        iresize: true,
        imove: true,
        autoSize: false
    }, params);

    this.$ = $("<div class=\"modal-wrap js icloser\"></div>")
        .appendTo($modalContainer);

    const that = this;
    const $box = that.$;
    const menuHTML = "";
    const title = params.title || "";
    const widthStep = params.widthStep || 50;

    that.params = params;
    $box.data("modal", this);

    that.ihelp = params.ihelp;
    that.imin = params.imin;
    that.ifull = params.ifull;
    that.iresize = params.iresize;
    that.imove = params.imove;
    that._autoSize = params.autoSize;

    that.widthStep = widthStep;
    $box
        .addClass("drag-modal theme-background-color theme-border-color-dark1")
        .removeClass("icloser")
        .html([
            "<div class='modal-top-bar imove'>",
            that.imove ? "<div class='modal-mover imove'></div>" : "",
            "<div class='modal-title imove' title='" + title + "'>",
            f.escapeHtml(title),
            "</div>",
            "<div class='modal-top-bar-right'>",
            that.ihelp ? "<div class='modal-help ihelp fa'></div>" : "",
            that.imin ? "<div class='modal-min imin'></div>" : "",
            that.ifull ? "<div class='modal-full ifull'></div>" : "",
            "<div class='modal-close icloser'></div>",
            "</div>",
            "</div>",
            menuHTML,
            "<div class='modal-content-wrap iresize'>",
            "<div class='modal-content'>",
            params.html || "",
            "</div>",
            "</div>"
        ].join(""));

    // разварот по двойному клику
    that.listenTo($box.find(".modal-top-bar"), "dblclick", function(e) {

        if ( !$(e.target).is(".modal-top-bar, .modal-title") ) {
            return;
        }

        e.preventDefault();
        that.full();
    });

    if ( that.imin ) {
        $box.addClass("imin");
    }


    if ( that.ifull ) {
        $box.addClass("ifull");
    }


    if ( that.iresize ) {
        $box.addClass("iresize");
    }

    if ( that.imove ) {
        $box.addClass("imove");
    }

    that.$titleWrap = that.$.find(".modal-title-wrap");
    that.$title = that.$.find(".modal-title");
    that.title = params.title || "";

    that.minw = params.minw || that.minw || DragModal._globalConfig.minw || 150;
    that.minh = params.minh || that.minh || DragModal._globalConfig.minh || 150;

    that.maxw = params.maxw || that.maxw || DragModal._globalConfig.maxw || 2000;
    that.maxh = params.maxh || that.maxh || DragModal._globalConfig.maxh || 2000;

    that.minx = params.minx || that.minx || DragModal._globalConfig.minx || 0;
    that.miny = params.miny || that.miny || DragModal._globalConfig.miny || 0;

    that._notHideAll = true; // смотреть modal.js

    that.initMouseAction();
    if ( that.cssName ) {
        this.$.addClass(that.cssName);
    }

    that._selectType = "multy";
    if ( "select" in params ) {
        that._selectType = params.select;
    }

    if ( !that._autoSize ) {
        that.setSize(params);

        that.listenTo($(window), "resize", function() {
            if ( that.isFull ) {
                that.full({
                    hideAnotherModals: false
                });
                that.trigger("resize");
            } else if ( !that.cssName || !~that.cssName.search(/box-modal/i) ) {
                that.setSize();
            }
        });
    } else {
        this.$.addClass("auto-size");
        this.autoSize();
    }

    that.$box = that.$.find(".modal-content");
    that.box = that.$box.get(0);

    that.listenTo(that.$box, "scroll", function() {
        this.trigger("scroll", this.getInnerScroll());
    }.bind(this));

    if (
        params.full
            || isMobile
            && params._mobileFull !== false // UIModal
    ) {
        this.full();
    }

    that.on("*", function(name) {
        const args = [].slice.call(arguments).slice(1);
        const method = that["on_" + name];

        if ( f.isFunction(method) ) {
            method.apply(that, args);
        }
    });

    return that;
};

DragModal.prototype.getBoxSize = function() {
    const leftPadding = 3;
    const rightPadding = 3;
    const bottomPadding = 3;
    const topPadding = 20;

    const size = {
        width: this.width,
        height: this.height - topPadding
    };

    if ( !this.isFull ) {
        size.width -= leftPadding;
        size.width -= rightPadding;
        size.height -= bottomPadding;
    }

    return size;
};

// сделать заголовок страницы заголовком окна
const $title = $("title:first");
const _defTitle = $title.text();
DragModal.prototype.syncPageTitle = function(setDefaultTitle) {
    $title.text(!setDefaultTitle ? this.title : _defTitle);
};

DragModal.prototype.getModalButtons = function() {
    return [
        "<div class=\"modal-top-bar-right\">",
        this.imin ? "	<div class=\"modal-min imin\"></div>" : "",
        this.ifull ? "	<div class=\"modal-full ifull\"></div>" : "",
        "	<div class=\"modal-close icloser\"></div>",
        "</div>"

    ].join("");
};

DragModal.prototype.getInnerScroll = function() {
    return {
        top: this.box.scrollTop,
        left: this.box.scrollLeft
    };
};

DragModal.prototype.toggleFull = function() {
    if ( !this.isFull ) {
        this.full();
    } else {
        this.unfull();
    }
};

DragModal.prototype.toggleMin = function() {
    if ( !this.isMin ) {
        this.min();
    } else {
        this.unmin();
    }
};

DragModal.prototype.setSize = function(params) {
    params = params || {};

    const that = this;
    const wind = f.getWindowSize();
    const width = that.mathSize(
        params.width || that.width,
        wind.width - DragModal._globalConfig.minx,
        "w"
    );
    const height = that.mathSize(
        params.height || that.height,
        wind.height,
        "h"
    );
    const $div = that.$;
    const css = {};
    const firstResize = !that.width || !that.height || params.firstResize;
    const toCenter = params.center || firstResize;
    const size = {
        width,
        height
    };
    const scroll = {
        top: 0,
        left: 0
    };
    const cy = scroll.top + (wind.height - size.height) / 2;
    const cx = DragModal._globalConfig.minx
            + scroll.left
            + ((wind.width - DragModal._globalConfig.minx) - size.width) / 2;
    let moved = false;

    if ( that.x + size.width > wind.width || toCenter ) {
        that.x = cx;
        moved = true;
    }
    if ( that.y + size.height > wind.height || toCenter ) {
        that.y = cy;
        moved = true;
    }

    if ( moved ) {
        this.autoSwap();
        css.left = this.x + "px";
        css.top = this.y + "px";
    }

    css.width = size.width + "px";
    css.height = size.height + "px";
    $div.css(css);

    that.width = size.width;
    that.height = size.height;

    if ( !firstResize ) {
        if ( that.width != width || that.height != height ) {
            that.trigger("resize", size);
        }
    }

    if ( !firstResize && moved ) {
        that.trigger("move", {
            x: that.x,
            y: that.y
        });
    }

    return that;
};

DragModal.prototype.autoSize = function() {
    const $modal = this.$;
    const size = $modal.realSize();
    const windowSize = f.getWindowSize();

    this.width = size.width;
    this.height = size.height;
    this.x = (windowSize.width - size.width) / 2;
    this.y = (windowSize.height - size.height) / 2;
    this.autoSwap();

    this.$.css({
        top: this.y + "px",
        left: this.x + "px"
    });
};

DragModal.prototype.autoSwap = function() {
    const otherModals = $(".modal-wrap").toArray()
        .map((modalWrapElement) => $(modalWrapElement).data("modal"))
        .filter((modal) => modal !== this);

    while ( this.needSwap(otherModals) ) {
        this.x += 20;
        this.y += 10;
    }
};

DragModal.prototype.needSwap = function(otherModals) {
    return otherModals.some((otherModal) =>
        otherModal.x === this.x
        && otherModal.y === this.y
    );
};

DragModal.prototype.mathSize = function(sizeX, windowSizeX, vectorName) {
    // задано вручную
    if ( this.params[vectorName == "w" ? "width" : "height"] ) {
        sizeX = Math.min(sizeX, windowSizeX - 10);
    }
    // авто
    else if ( !sizeX || sizeX > windowSizeX ) {
        if ( windowSizeX > 800 ) {
            sizeX = Math.max(windowSizeX / 2, 800);
        } else if ( windowSizeX > 400 ) {
            sizeX = windowSizeX - 100;
        } else {
            sizeX = windowSizeX;
        }
    }

    sizeX = Math.max(this["min" + vectorName], sizeX);
    sizeX = Math.min(this["max" + vectorName], sizeX);

    return sizeX;
};

DragModal.prototype.show = function(options, callback) {
    if ( f.isFunction(options) ) {
        callback = options;
        options = {};
    }

    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    options = f.deepMixin({
        trigger: true
    }, options);

    const that = this;

    activeModal = that;
    that.syncPageTitle();
    that.upMyZIndex();
    that.$[0].style.display = "block";
    setTimeout(function() {
        if ( options.trigger ) {
            that.trigger("show");
        }

        callback();
    }, that.openTime);

    return that;
};

DragModal.prototype.toggle = function() {
    if ( this.$.is(":hidden") ) {
        this.show();
    } else {
        this.hide();
    }
};

DragModal.prototype.setTitle = function(title) {
    const that = this;

    that.title = title;
    that.$title.html(title).attr("title", title);

    return that;
};

DragModal.prototype.saveSize = function(firstSet) { // firstSet @see GridApp.js (setWidthByFullToolbar)
    // LW-2851 при открытии формы несколько раз вызывается функция full
    // поэтому проверим что размеры действительно изменились
    // прежде чем затерать предыдущие.
    let windowSize = f.getWindowSize();
    if ( this.width != windowSize.width - DragModal._globalConfig.minx || firstSet ) {
        this._sizeBeforeFull = {
            width: this.width,
            height: this.height
        };
    }
};

DragModal.prototype.full = function(options) {
    options = options || {};
    const that = this;
    const $div = that.$;
    const div = $div[0];
    const trigger = !that.isFull;
    let scroll;
    let windowSize;

    that.isFull = true;

    if ( options.hideAnotherModals !== false ) {
        // Когда пользователь кликает куда-то, или делает что-либо с окном,
        // то его действия могут приветси к процессу "Recalculate styles"
        // который в свою очередь пересчитывает стили и размеры всех элементов на странице.
        // Если элементов на странице много, то пересчет занимает 6-10 секунд (зависит от множества факторов)
        // Более того, в момент Дооолгого пересчета, браузер может затупить и перерисовать старые окна (мистическое видео от Одисея (клиента) LW-992).
        //
        // Чтобы пофиксить проблему (дело не в оптимизации, а в баге браузера)
        // нужно скрывать старые окна.
        // Когда открываешь окно на полный размер, оно закрывает собой другие окна.
        // А значит их можно скрыть (display: none элементы не участвуют в "Recalculate styles")
        for (let id in DragModal.modals) {
            let anotherModal = DragModal.modals[id];
            // ищем окна, открытые на полный размер и скрываем их
            if ( anotherModal == this ) {
                continue;
            }
            if ( !anotherModal.isFull ) {
                continue;
            }
            if ( anotherModal.isMin ) {
                continue;
            }
            anotherModal.$[0].style.display = "none";
        }
    }

    windowSize = f.getWindowSize();
    scroll = f.getScroll();

    div.classList.add("full");
    div.style.width = windowSize.width + "px";
    div.style.height = windowSize.height + "px";
    div.style.left = scroll.left + "px";
    div.style.top = scroll.top + "px";

    that.saveSize();

    that.width = windowSize.width - DragModal._globalConfig.minx;
    that.height = windowSize.height;

    this.syncPageTitle();

    if ( trigger ) {
        that.trigger("resize full");
    }

    return that;
};

DragModal.prototype.unfull = function() {
    const that = this;
    const div = that.$[0];
    const trigger = that.isFull;

    that.isFull = false;
    that.syncPageTitle();

    that.width = that._sizeBeforeFull.width;
    that.height = that._sizeBeforeFull.height;

    div.style.left = that.x + "px";
    div.style.top = that.y + "px";
    div.style.width = that._sizeBeforeFull.width + "px";
    div.style.height = that._sizeBeforeFull.height + "px";

    div.classList.remove("full");
    this._showLastModal();

    if ( trigger ) {
        that.trigger("unfull resize");
    }

    return that;
};

DragModal.prototype._showLastModal = function() {
    let maxIndex = 0;
    let lastModal = null;

    for (let id in DragModal.modals) {
        let anotherModal = DragModal.modals[id];
        // ищем окна, открытые на полный размер,
        // берем последнее открытое, и показываем его
        if ( anotherModal == this ) {
            continue;
        }
        if ( !anotherModal.isFull ) {
            continue;
        }
        if ( anotherModal.isMin ) {
            continue;
        }

        if ( anotherModal._zIndex > maxIndex ) {
            maxIndex = anotherModal._zIndex;
            lastModal = anotherModal;
        }
    }
    if ( lastModal ) {
        lastModal.$[0].style.display = "block";
    }
};

DragModal.prototype.min = function() {
    const that = this;
    const trigger = !that.isMin;
    that.isMin = true;
    that.$.hide().addClass("min");

    this._showLastModal();

    if ( trigger ) {
        that.trigger("min");
    }
    that.syncPageTitle();
    return that;
};

DragModal.prototype.unmin = function() {
    const that = this;
    const trigger = that.isMin;

    that.isMin = false;
    that.$.show().removeClass("min");

    if ( trigger ) {
        that.trigger("unmin");
    }

    this.upMyZIndex();
    that.syncPageTitle();
    return that;
};

DragModal.prototype.upMyZIndex = function() {
    this.$[0].style.zIndex = ++zIndex;
    this._zIndex = zIndex;
    this.trigger("zup");
};

// отсюда растет интерактив
DragModal.prototype.initMouseAction = function() {
    const that = this;
    const $div = that.$;

    that.dragOverStack = [];
    that.selectedStack = [];

    that.listenTo($(window), "touchstart", function(e) {
        const $parent = $(e.target).parents(".modal-wrap:first");
        if ( $parent.get(0) == that.$.get(0) ) {
            proccess(e);
        }
    });

    that.listenTo($div, "mousedown", proccess);

    function proccess(e) {
        that.trigger("beforeMouseAction", e);

        if ( e.which != 1 && e.type == "mousedown" ) {
            return;
        }

        const target = e.target;
        const $target = $(target);
        let $elem;

        if ( !$target.hasClass("nozup") ) {
            that.upMyZIndex();
        }

        activeModal = that;
        that.syncPageTitle();

        if ( $target.hasClass("ihelp") ) {
            that.trigger("help");
        }

        if ( $target.hasClass("icloser") ) {
            that.hide();
        }
        else if ( $target.hasClass("imove") && that.imove ) {
            // пермещение окна
            e.preventDefault();
            that.startMouseAction(e, "move");
        }
        else if ( $target.hasClass("iresize") && that.iresize ) {
            // изменение размеров окна
            e.preventDefault();
            that.startMouseAction(e, "resize");
        }
        else if ( $target.hasClass("imin") && that.imin
                || $target.hasClass("ifull") && that.ifull ) {
            e.preventDefault();

            if ( $target.hasClass("imin") ) {
                that.toggleMin();
            } else {
                that.toggleFull();
            }

            return;
        }


        // "Специальные" элементы
        // .idrag - элемент, который можно перетаскивать из окна в окно (или в элемент .idrop)
        // .iselect - элемент, который можно выделить по клику


        // если $target подподает под селектор, то она и есть нужный элемент,
        // в противном случае ищем селектор среди родителей
        $elem = that.findElemByTarget($target, [".idrag", ".iselect"]);

        // элемент не нашли
        if ( !$elem.length ) {
            return that;
        }

        if ( !$elem.hasClass("iselect") ) {
            that.unselectAll(e);
        }

        if ( $elem.hasClass("idrag") ) {

            // начало перемещние вист на первом событии mousemove
            that._dragStarted = false;
            that.startMouseAction(e, "drag");
        }
    }
};

// поиск по селектору elemSelector или .iselect, .idrag, .idrop
// elemSelector может быть строкой или массивом строк
// элемента среди родителей event.target
DragModal.prototype.findElemByTarget = function($target, elemSelector) {
    if ( !elemSelector ) {
        elemSelector = [".idrag", ".iselect", ".idrop"];
    } else if ( typeof elemSelector == "string" ) {
        elemSelector = [elemSelector];
    }

    const $elem = $target.is(elemSelector.join(", "))
        ? $target : $target.parents(elemSelector.map(function(str) {
            return str + ":first";
        }).join(", "));

    return $elem;
};

DragModal.prototype.startDrag = function(e, $source) {
    const that = this;
    const toDrop = [];
    let stack = that.selectedStack.slice();
    let dragBus;
    let $icon;

    if ( $source.hasClass("iselect") && that._selectType ) {
        if ( !$source.hasClass("selected") ) {
            // элемент не выделен
            that.selectElem(e, $source);
            stack = that.selectedStack.slice();
        }
    } else {
        // перемещать можно не только выделенные элементы
        stack = [$source].concat(stack);
        $source.addClass("drag-start");
    }

    stack.forEach(function($elem) {
        // запрашивеам данные в "автобусе"
        dragBus = that.getDragBus(e, $elem);
        if ( !dragBus ) {
            return;
        }

        //$elem.addClass('drag-start');
        toDrop.push({
            $elem,
            dragBus
        });
    });

    if ( !toDrop.length ) {
        return that;
    }

    e.preventDefault();
    $icon = that.createMoveIcon(e, toDrop);

    $icon
        .data({
            modal: that,
            toDrop
        });

    e.$icon = $icon;
    that.startMouseAction(e, "drag");

    return that;
};

DragModal.prototype.unselectAll = function(e, /* кроме*/ $source) {
    const that = this;
    const stack = that.selectedStack;
    const toUnselect = [];

    stack.forEach(function($elem) {
        if ( $source && ($elem[0] == $source[0]) ) {
            return;
        }

        toUnselect.push($elem);
    });

    toUnselect.forEach(function($elem) {
        that.unselectElem(e, $elem);
    });

    that.selectedStack = [];
    if ( $source && $source.hasClass("selected") ) {
        that.selectedStack.push($source);
    }

    return that;
};

DragModal.prototype.selectedIndexOf = function($elem) {
    let index = -1;
    this.selectedStack.forEach(function($el, i) {
        if ( $el[0] == $elem[0] ) {
            index = i;
            return false;
        }
    });
    return index;
};

DragModal.prototype.selectElem = function(e, $elem) {
    const that = this;
    const index = that.selectedIndexOf($elem);
    let stack = that.selectedStack;

    // запрещено выделение
    if ( !that._selectType ) {
        return that;
    }

    // можно объединить в одно условие, но так мне нравится больше...
    //
    if ( that._selectType != "multy" ) {
        // если разрешен выбор только одного элемента,
        if ( stack.length >= 1 ) {
            // если в стеке есть элементы
            if ( index == -1 ) {
                // если в стеке не текущий элемент
                that.unselectAll();
                stack = [];
            }
        }
    }

    if ( index == -1 ) {
        stack.push($elem);
    }

    if ( !$elem.hasClass("selected") ) {
        $elem.addClass("selected");
        $elem.trigger("select", e);
    }

    that.selectedStack = stack;

    return that;
};

DragModal.prototype.unselectElem = function(e, $elem) {
    if ( !$elem.hasClass("iselect") ) {
        return this;
    }

    const that = this;
    let index = that.selectedIndexOf($elem);
    const stack = that.selectedStack;

    if ( index != -1 ) {
        stack.splice(index, 1);
    }

    if ( $elem.hasClass("selected") ) {
        $elem.removeClass("selected");
        $elem.trigger("unselect", e);
    }

    return that;
};

DragModal.prototype.toggleSelect = function(e, $elem) {
    const that = this;

    if ( $elem.hasClass("selected") ) {
        that.unselectElem(e, $elem);
    } else {
        that.selectElem(e, $elem);
    }

    return that;
};

DragModal.prototype.createMoveIcon = function(e, toDrop) {
    let name = "";
    let mask = "group";
    let $icon;
    let dragBus;

    if ( toDrop.length == 1 ) {
        dragBus = toDrop[0].dragBus;
        name = dragBus.name;
        mask = dragBus.mask;
    }

    $icon = $("body")
        .append([
            "<div class='move-icon no-select " + mask + "'>",
            "<h1>" + name + "</h1>",
            "</div>"
        ].join(""))
        .children(".move-icon:last");

    $icon.css({
        "z-index": zIndex + 10000,
        left: 10 + e.pageX + "px",
        top: 10 + e.pageY + "px",
        visibility: "hidden"
    });

    return $icon;
};

DragModal.prototype.startMouseAction = function(e, state) {
    const that = this;
    if ( that.isFull && (state == "move" || state == "resize") ) {
        return that;
    }

    $("body").addClass("no-select iframes-pointer-events-none");
    that._mouseState = state;

    let point = {
        x: e.pageX,
        y: e.pageY
    };
    if ( e.type == "touchstart" ) {
        point = f.getTouchPoint(e);
    }

    that.startData = {
        mx: point.x,
        my: point.y,
        x: that.x,
        y: that.y,
        width: that.width,
        height: that.height,
        $icon: e.$icon,
        vector: {
            x: (point.x < that.x + that.width * 0.01) ? -1 : 1 // that.width * 0.01  Служит для определения начала драга от левого края
        }
    };

    targetModal = that;
    return that;
};

DragModal.prototype.mousemove = function(e) {

    const that = this;
    const startData = that.startData;
    const point = e.type == "mousemove"
        ? {
            x: e.pageX,
            y: e.pageY
        }
        : f.getTouchPoint(e);

    const vector = startData.vector;
    const mx = point.x;
    const my = point.y;
    const dx = mx - startData.mx;
    const dy = my - startData.my;
    const $div = that.$;
    const div = $div[0];

    const nSize = {
        w: Math.max(startData.width + dx * vector.x, that.minw),
        h: Math.max(startData.height + dy, that.minh)
    };
    const nPoint = {
        x: startData.x + dx,
        y: startData.y + dy
    };
    let trigger = false;
    const state = that._mouseState;

    if ( state == "drag" ) {
        that.processDrag(e);
    } else if ( state == "resize" ) {
        if ( that.width != nSize.w || that.height != nSize.height ) {
            trigger = true;
        }

        if ( vector.x < 1 && that.width != that.minw ) {
            that.x = Math.max(that.minx, mx);
        }

        this.width = nSize.w;
        this.height = nSize.h;

        div.style.width = nSize.w + "px";
        div.style.height = nSize.h + "px";
        div.style.left = that.x + "px";
        div.style.top = that.y + "px";

        if ( this.onMousemoveResizeState ) {
            this.onMousemoveResizeState();
        }
    }

    if ( state == "move" ) {
        if ( that.x != nPoint.x || that.y != nPoint.y ) {
            trigger = true;
        }

        that.x = Math.max(that.minx, nPoint.x);
        that.y = Math.max(that.miny, nPoint.y);

        div.style.left = that.x + "px";
        div.style.top = that.y + "px";
    }

    if ( trigger && state != "drag" ) {
        that.trigger(state, e, {
            _dontGetRect: true
        });
    }

    return that;
};

DragModal.prototype.processDrag = function(e) {
    const that = this;
    const target = e.target;
    const $target = $(target);
    const $elem = that.findElemByTarget($target);

    if ( !that._dragStarted && $elem.hasClass("idrag") ) {
        that.startDrag(e, $elem);
        that._dragStarted = true;
    } else {
        that.dragMove(e, $elem);
    }

    return that;
};

DragModal.prototype.dragMove = function(e, $drop) {
    const that = this;
    const startData = that.startData;
    const $icon = startData.$icon;
    const toDrop = $icon && $icon.data("toDrop");
    const fromModal = $icon && $icon.data("modal");
    const my = e.pageY;
    const mx = e.pageX;
    const stack = that.dragOverStack;

    if ( !$icon ) {
        return that;
    }

    $icon.css({
        left: 10 + mx + "px",
        top: 10 + my + "px",
        visibility: "visible"
    });

    if ( !$drop.length ) {
        that.clearDragOverStack();
        return that;
    }

    if ( $drop.hasClass("drag-over") ) {
        return that;
    }

    for (let i = 0, n = toDrop.length; i < n; i++) {
        if ( toDrop[i].$elem[0] == $drop[0] ) {
            that.clearDragOverStack();
            return that;
        }
    }

    that.clearDragOverStack();
    stack.push($drop);

    $drop
        .addClass("drag-over")
        .trigger("drag-over", {
            $icon,
            toDrop,
            fromModal
        });

    return that;
};

DragModal.prototype.clearDragOverStack = function() {
    const that = this;

    that.dragOverStack.forEach(function($drag) {
        $drag.removeClass("drag-over");
        $drag.trigger("drag-out");
    });

    return that;
};

DragModal.prototype.stopMouseAction = function(e) {
    const that = this;
    const target = e.target;
    const $target = $(target);
    const startData = that.startData;
    const $icon = startData.$icon;
    let data = {};
    // мышку передвинули;
    const isClick = startData.mx == e.pageX && startData.my == e.pageY;
    const state = this._mouseState;
    let isDrop = false;
    let $drop;
    let $elem;
    let toDrop;
    let $modal;
    let tmp;

    isDrop = state == "drag" && $icon;
    that._mouseState = false;

    if ( state ) {
        this.trigger(state + "End");
    }

    $elem = that.findElemByTarget($target);
    // обработка выделения
    if ( isClick && $elem.hasClass("iselect") ) {
        that.toggleSelect(e, $elem);
    }

    // если это не событие "броска элемента(ов)", то выходим
    if ( !isDrop || isClick ) {
        if ( $icon && $icon.get(0) ) {
            $icon.get(0).outerHTML = "";
        }
        that.clearDragOverStack();
        return that;
    }

    // элемент приемник
    $drop = $elem;
    // массив "броска"
    toDrop = $icon.data("toDrop");
    // сбрасываем css-класс
    toDrop.forEach(function(a) {
        a.$elem.removeClass("drag-start");
    });

    // если нет приемника элемента(ов), то выходим
    if ( !$drop.length ) {
        that.clearDragOverStack();
        $icon.get(0).outerHTML = "";
        return that;
    }

    // проверяем куда происходит бросок и сбрасываем классы 'drag-start'
    for (let i = 0, n = toDrop.length; i < n; i++) {
        tmp = toDrop[i];

        // если бросок в "элементы-источники", то выходим
        if ( tmp.$elem[0] == $drop[0] ) {
            that.clearDragOverStack();
            $icon.get(0).outerHTML = "";
            return that;
        }
    }

    that.unselectAll();
    that.clearDragOverStack();

    data = {
        event: e,
        $drop,
        $icon,
        fromModal: $icon.data("modal"),
        toDrop
    };

    // проверям находится ли приемник в модальном окне
    $modal = $drop.hasClass("modal-wrap") ? $drop : $drop.parents(".modal-wrap");
    if ( $modal.length ) {
        data.$modal = $modal;
        data.modal = $modal.data("modal");
    }

    that.trigger("drop", data);
    $drop.trigger("drop", data);

    $icon.get(0).outerHTML = "";

    return that;
};

// dragBus - автобус, который доставит данные с одной остонавки на другую (модальные окна)
DragModal.prototype.getDragBus = function( /* e, $elem */ ) {
    return {
        name: "test",
        mask: "lnk"
    };
};

DragModal.prototype.on_drop = function(data) {
    console.log(data);
};

DragModal.prototype.on_show = function() {};
DragModal.prototype.on_scroll = function() {};
DragModal.prototype.on_hide = function() {};

DragModal.prototype.on_resize = function(e, options) {
    if ( options && options._dontGetRect ) {
        return;
    }

    let rect = this.$[0].getBoundingClientRect();
    this._width = rect.width;
    this._height = rect.height;
};

DragModal.prototype.hide = function(params, callback) {
    if ( arguments.length == 1 && f.isFunction(params) ) {
        callback = params;
        params = {};
    }
    params = f.deepMixin(params, {
        trigger: true
    });

    this.$.fadeOut(callback);
    this.syncPageTitle(true);

    this._showLastModal();

    if ( params.trigger ) {
        this.trigger("hide");
    }
};

DragModal.prototype.destroy = function() {
    if ( activeModal == this ) {
        activeModal = false;
    }

    if ( targetModal == this ) {
        targetModal = false;
    }

    this.$.data("modal", false);
    this.$.find("*").data("modal", false);
    this.clearEvents();

    this._showLastModal();

    delete DragModal.modals[this.id];

    if ( this.$[0].parentNode ) {
        this.$[0].outerHTML = "";
    }

    $title.text("");
};

let targetModal;
const keyCodes = {};
const hotKeys = {
    17: "ctrl",
    18: "alt",
    27: "esc",
    13: "enter",
    16: "shift",
    67: "c",
    86: "v",
    88: "x",
    65: "a",
    8: "backspace",
    38: "up",
    40: "down",
    37: "left",
    39: "right",
    36: "home",
    46: "delete",
    35: "end"
};

$(function() {
    $(window)
        .on("mousemove touchmove", function(e) {
            if ( !targetModal ) {
                return;
            }

            targetModal.mousemove(e);
        })
        .on("mouseup touchend", function(e) {
            if ( targetModal ) {
                targetModal.stopMouseAction(e);
            }

            targetModal = false;
            $("body").removeClass("no-select iframes-pointer-events-none");
        });

    $(document)
        .on("keydown", function(e) {
            const n = e.keyCode;
            const hot = hotKeys[n];
            keyCodes[n] = true;
            if ( hot ) {
                keyCodes[hot] = true;
            }
        })
        .on("keyup", function(e) {
            const n = e.keyCode;
            const hot = hotKeys[n];

            if ( activeModal && keyCodes.esc ) {
                //activeModal.hide();
            }

            delete keyCodes[n];
            if ( hot ) {
                delete keyCodes[hot];
            }

        });

});

DragModal._globalConfig = {
    minx: 72,
    miny: 0,
    minw: 150,
    minh: 150
};

// работа с drag'n'drop извне
DragModal.dragMove = function(params) {
    const x = params.x;
    const y = params.y;

    const modal = DragModal.getModalByCoords(x, y);
    if ( !modal ) {
        return;
    }

    // TODO: придумать более быстрый способ
    $(".files-drag-over").removeClass("files-drag-over");

    const $idrops = modal.$.find(".idrop");
    let $idrop;
    $idrops.each(function(i, el) {
        const rect = el.getBoundingClientRect();

        if ( x > rect.left && x < rect.left + rect.width
                && y > rect.top && y < rect.top + rect.height
        ) {
            $idrop = $(el);
            return false;
        }
    }.bind(this));

    if ( !$idrop ) {
        return;
    }

    $idrop.addClass("files-drag-over");
};

// находим модяльное окно по точке, которое входит в область окна
DragModal.getModalByCoords = function(x, y) {
    const modals = DragModal.modals;
    const modalsByCoords = [];
    let modal;

    for (const key in modals) {
        modal = modals[key];
        if ( !(modal instanceof DragModal) ) {
            continue;
        }

        if (
            !modal.isMin && (
                x > modal.x && x < modal.x + modal.width
                    && y > modal.y && y < modal.y + modal.height
                    || modal.isFull
            )
        ) {
            modalsByCoords.push(modal);
        }
    }

    let maxIndex = -1;
    let maxZindex = -1;
    let zIndex;
    for (let i = 0, n = modalsByCoords.length; i < n; i++) {
        modal = modalsByCoords[i];
        zIndex = +modal.$.css("z-index");
        if ( zIndex > maxZindex ) {
            maxZindex = zIndex;
            maxIndex = i;
        }
    }
    return modalsByCoords[maxIndex];
};

// singleModal - модальное окно,
// которое не открывается повторно,
// если этого не надо.
// Например есть кнопка "выбрать контейнеры",
// по нажатию на нее откроется окно с таблицой контейнеров.
// обычное окно каждый раз по клику будет создовать новое окно.
// singleModal по клику создаст одно окно и при повторном клике на кнопку
// будет показывать старое окно, если оно не было закрыто
DragModal.single = function(params) {
    const ModalConstructor = this;
    let modal;

    const single = new Events();

    single.show = function(callback) {
        if ( modal ) {
            modal.show(callback);
        } else {
            if ( f.isFunction(ModalConstructor.show) ) {
                modal = ModalConstructor.show(params);
            } else {
                modal = new ModalConstructor(params);
            }

            modal.on("hide", function() {
                modal.destroy();
                modal = null;
            });
            modal.show(callback);

            single.modal = modal;
        }
    };

    single.hide = function() {
        if ( modal ) {
            modal.hide();
        }
    };

    return single;
};

const extend = DragModal.extend;
DragModal.extend = function() {
    const Child = extend.apply(this, arguments);

    Child.single = DragModal.single;

    return Child;
};

DragModal.zIndexPlus = function() {
    return ++zIndex;
};

export default DragModal;
